import React from 'react';
import { Users, Heart, Sparkles } from 'lucide-react';

const WhoWeAre = () => {
  return (
    <section id="who-we-are" className="py-20 px-4 bg-white scroll-mt-20">
      <div className="container mx-auto max-w-4xl">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-emerald-50 text-emerald-700 px-4 py-2 rounded-full text-sm font-medium mb-4 border border-emerald-100">
            <Users className="h-4 w-4" />
            <span>Meet the Team</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Who We Are
          </h2>
        </div>

        <div className="bg-gradient-to-br from-emerald-50 to-blue-50 p-8 md:p-12 rounded-2xl border-2 border-emerald-100 shadow-lg">
          <div className="prose prose-lg max-w-none">
            <p className="text-slate-700 text-lg leading-relaxed mb-6">
              We're a <strong>brother–sister duo</strong> born and raised in Florida, which basically means we grew up organizing pool toys, hurricane supplies, and every cousin's leftover flip-flops. Now we live in (and proudly serve) <strong>Winter Park</strong>, helping people transform their garages from <em>"I'll deal with that later"</em> to <em>"Wait… this is actually nice?"</em>
            </p>

            <p className="text-slate-700 text-lg leading-relaxed mb-6">
              We started this business because we realized two things:
            </p>

            <div className="grid md:grid-cols-2 gap-6 mb-6">
              <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
                <div className="flex items-start gap-3">
                  <div className="bg-red-100 p-2 rounded-lg">
                    <span className="text-2xl">😅</span>
                  </div>
                  <div>
                    <p className="text-slate-700 font-medium">
                      Most people avoid cleaning their garage like they avoid I-4 at rush hour.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
                <div className="flex items-start gap-3">
                  <div className="bg-emerald-100 p-2 rounded-lg">
                    <Sparkles className="h-6 w-6 text-emerald-600" />
                  </div>
                  <div>
                    <p className="text-slate-700 font-medium">
                      We weirdly enjoy it.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <p className="text-slate-700 text-lg leading-relaxed mb-6">
              Whether your garage needs decluttering, organizing, a full makeover, or just someone brave enough to open the mystery bins you've been ignoring, <strong>we've got you covered</strong>.
            </p>

            <div className="bg-white p-6 rounded-xl border-2 border-emerald-200 text-center">
              <Heart className="h-8 w-8 text-emerald-600 mx-auto mb-3" />
              <p className="text-slate-800 text-xl font-semibold">
                We bring Florida grit, a little sibling banter, and a whole lot of satisfaction to every project.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoWeAre;
